import { QueryEntity, EntityState, EntityStore } from "@datorama/akita";
import { OnDestroy } from "@angular/core";
import { FirebaseService, QueryFn } from "./firebase.service";
import { DocOptions, SyncOptions } from "akita-ng-fire";
import { map, take } from "rxjs";
import { environment } from "../../environments/environment";

export class FirebaseQuery<S extends EntityState> extends QueryEntity<S> {
  constructor(protected store: EntityStore<S>, protected service: FirebaseService<S>) {
    super(store);
  }

  syncActive(options: S["active"] extends Array<infer _I> ? string[] : DocOptions, syncOptions?: Partial<SyncOptions>) {
    return this.service.syncActive(options, syncOptions);
  }

  syncCollectionUntilDestroyed(component: OnDestroy, query?: QueryFn) {
    if (environment.e2e) {
      this.store.setLoading(false);
      return null;
    }

    return this.service.syncCollectionUntilDestroyed(component, query);
  }

  syncCollection(query?: QueryFn) {
    if (environment.e2e) {
      this.store.setLoading(false);
      return this.selectAll().pipe(take(1));
    }

    return this.service.syncCollection(query, { reset: !!query }).pipe(map(x => x.map(y => y.doc.data())));
  }

  syncOnce(query?: QueryFn) {
    if (environment.e2e) {
      this.store.setLoading(false);
      return null;
    }

    return this.service.syncCollectionOnce(query);
  }

  clearActive() {
    this.store.setActive(null);
  }

  setActive(options: S["active"]) {
    this.store.setActive(options);
  }
}
